export const SET_SERVERTIME_INFO = 'SET_SERVERTIME_INFO'

export const RESTE_ALL_INFO_DATA = 'RESTE_ALL_INFO_DATA'